<template>
    <div class="ws-switch-component">
        <div class="ws-switch" :class="checked ? 'yes':'no'" @click="toggleValue">
            <div class="ws-switch-knob"></div>
        </div>
        <div v-if="noLabel || yesLabel" class="ws-switch-label">{{ checked ? yesLabel : noLabel }}</div>
    </div>
    
</template>

<script>
export default {
    name: "WSSwitch",
    model: {
        prop: 'checked',
        event: 'input'
    },
    props: {
        noLabel: String,
        yesLabel: String,
        checked: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        toggleValue () {
            this.$emit('input', !this.checked);
        }
    }
}
</script>
